import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export const FloatingNotification = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [notificationData, setNotificationData] = useState({
    name: 'Florencia B.',
    location: 'La Plata',
    product: 'MegaPack + Instante Abundante 🏆',
    time: 'hace 9 minutos'
  });
  const buyers = [{
    name: 'Florencia B.',
    location: 'La Plata',
    product: 'MegaPack + Instante Abundante 🏆',
    time: 'hace 9 minutos'
  }, {
    name: 'Valentina G.',
    location: 'Buenos Aires',
    product: 'MegaPack Código de Abundancia',
    time: 'hace 14 minutos'
  }, {
    name: 'Carolina R.',
    location: 'Córdoba',
    product: 'MegaPack + Instante Abundante 🏆',
    time: 'hace 22 minutos'
  }, {
    name: 'Marcela F.',
    location: 'Rosario',
    product: 'MegaPack Código de Abundancia',
    time: 'hace 35 minutos'
  }, {
    name: 'Luciana M.',
    location: 'CABA',
    product: 'MegaPack + Instante Abundante 🏆',
    time: 'hace 41 minutos'
  }];
  useEffect(() => {
    // Initial delay before showing the first notification
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    // Cycle notifications
    const cycleTimer = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
        // Randomize time slightly for realism
        const randomTime = `hace ${Math.floor(Math.random() * 59) + 1} minutos`;
        setNotificationData({
          ...randomBuyer,
          time: randomTime
        });
        setIsVisible(true);
      }, 1000); // Wait 1s before showing the next one
    }, 30000); // Show a new notification every 30 seconds
    return () => {
      clearTimeout(initialTimer);
      clearInterval(cycleTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-101">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 25
    }} className="fixed bottom-4 left-4 md:bottom-8 md:left-8 z-50 max-w-sm" data-id="element-102">
          <div className="glass-panel bg-brand-surface/90 p-4 rounded-2xl shadow-2xl border-brand-gold/30 flex items-start space-x-4" data-id="element-103">
            <div className="bg-brand-green/20 p-2 rounded-full shrink-0 mt-1" data-id="element-104">
              <CheckCircle2 className="w-5 h-5 text-brand-green" data-id="element-105" />
            </div>
            <div data-id="element-106">
              <div className="text-xs text-brand-text/60 mb-1 flex items-center" data-id="element-107">
                🔔 Compra verificada • {notificationData.time}
              </div>
              <div className="text-sm font-medium text-brand-text mb-1" data-id="element-108">
                <span className="font-bold" data-id="element-109">{notificationData.name}</span> de{' '}
                {notificationData.location} compró
              </div>
              <div className="text-sm text-brand-gold font-medium" data-id="element-110">
                {notificationData.product}
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
};